var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-086f3af0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-row gap-3" };
const _hoisted_2 = { class: "mb-3" };
const _hoisted_3 = { class: "flex flex-row gap-2" };
const _hoisted_4 = { class: "bookAppointmentLabel" };
const _hoisted_5 = {
    key: 0,
    class: "mt-2 text-red-40 flex text-error-600"
};
const _hoisted_6 = { class: "bookAppointmentLabel" };
const _hoisted_7 = {
    key: 0,
    class: "mt-3"
};
const _hoisted_8 = { class: "bookAppointmentLabel" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
    key: 1,
    class: "mb-3"
};
const _hoisted_11 = { class: "bookAppointmentLabel" };
const _hoisted_12 = { class: "bookAppointmentLabel" };
const _hoisted_13 = { class: "bg-gray-50 py-4 px-3 rounded-lg mb-3" };
const _hoisted_14 = {
    key: 0,
    class: ""
};
const _hoisted_15 = { class: "flex items-center space-x-10 pb-3" };
const _hoisted_16 = { class: "bookAppointmentLabel" };
const _hoisted_17 = {
    key: 1,
    class: "mt-[15px] mb-[20px] flex items-center"
};
const _hoisted_18 = { class: "w-[260px] text-[11px]" };
const _hoisted_19 = { key: 2 };
const _hoisted_20 = { class: "mt-3 flex gap-4" };
const _hoisted_21 = { class: "mb-2 text-sm text-gray-700" };
const _hoisted_22 = { class: "mb-2 text-sm text-gray-700" };
const _hoisted_23 = {
    key: 3,
    class: "flex flex-row gap-2 mt-3"
};
const _hoisted_24 = { class: "w-1/2" };
const _hoisted_25 = { class: "bookAppointmentLabel" };
const _hoisted_26 = { class: "w-1/2" };
const _hoisted_27 = { class: "bookAppointmentLabel" };
const _hoisted_28 = {
    key: 3,
    class: "mt-2 text-red-40 flex text-error-600"
};
const _hoisted_29 = {
    key: 4,
    class: "mt-2"
};
const _hoisted_30 = {
    key: 1,
    class: "recurringEventsContainer"
};
const _hoisted_31 = {
    class: "text-gray-500 text-xs font-medium",
    id: "recurring-slots-info"
};
const _hoisted_32 = {
    key: 2,
    class: "text-error-700 mt-2 mb-2 flex justify-center items-center text-sm"
};
const _hoisted_33 = { class: "bookAppointmentLabel" };
const _hoisted_34 = { class: "flex mb-3" };
const _hoisted_35 = { class: "text-xs" };
const _hoisted_36 = { class: "text-xs" };
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "border-[0.5px] border-l-[0.2px] border-gray-200 mx-2 h-auto" }, null, -1));
import config from '@/config';
import AppState from '@/states/book_appointment';
import { HelpCircleIcon, RefreshCcw05Icon, Repeat02Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { UICheckbox, UIDatepicker, UIInput, UIRadio, UISelect, UISpin, UITooltip, } from '@gohighlevel/ghl-ui';
import moment from 'moment-timezone';
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { getCalendars, getTeams, getUsers } from '../../states/book_appointment';
import UIDatePicker from '../common/UIDatePicker.vue';
import RecurringEventsModal from './RecurringEventsModal.vue';
import ViewContacts from './ViewContacts.vue';
import { appointmentWizardState, bookRecurring, calendarDropDownOptions, computedTimezonesNew, contactTimezone, disableContactTimezone, fetchRRuleText, fetchSlots, hasContact, isEditingAppointment, recurringSlots, selectedCalendar, setSelectedCalendar, setSelectedTeamMember, teamMemberOptions, toggleRecurringModal, updateEndTime, updateStartTime, } from './appointmentWizardState';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BookAppointmentForm',
    setup(__props) {
        const { t } = useI18n();
        const dynamicHeight = ref('');
        const myDatePicker = ref(null);
        const isCalendarLoading = ref(false);
        // Parses a dateString using the specified format into a JavaScript Date object.
        function parseDate(dateString, format) {
            return moment(dateString, format).toDate();
        }
        function formatDate(dateObj, format) {
            return moment(dateObj).format(format);
        }
        // Handles changes in the selected period (month and year) on the calendar UI.
        const periodChanged = ({ month, year }) => {
            //
            const currentDate = moment(appointmentWizardState.appointmentDate, appointmentWizardState.format);
            const newDate = currentDate.set({
                year: year,
                month: month,
            });
            appointmentWizardState.appointmentDate = newDate.format(appointmentWizardState.format);
            if (moment(appointmentWizardState.lastFetchedAppointmentDate, appointmentWizardState.format).format('YYYY-MM') !==
                moment(appointmentWizardState.appointmentDate, appointmentWizardState.format).format('YYYY-MM')) {
                fetchSlots();
                appointmentWizardState.lastFetchedAppointmentDate =
                    appointmentWizardState.appointmentDate;
            }
        };
        // Sets the selected timezone for the appointment and fetches new appointment slots.
        const setSelectedTimezone = (e) => {
            appointmentWizardState.selectedTimezone = e;
            fetchSlots();
        };
        // Toggles the flag for allowing custom time and fetches new slots if necessary.
        const toggleShouldAllowCustomTime = () => {
            appointmentWizardState.slotError = '';
            AppState.shouldAllowCustomTime = !AppState.shouldAllowCustomTime;
            // Fetches rruleText if the custom time is allowed and the rruleText is not yet fetched.
            showRecurringSection.value &&
                !appointmentWizardState.rruleText &&
                fetchRRuleText();
            if (!AppState.shouldAllowCustomTime) {
                fetchSlots();
            }
        };
        const shouldAllowCustomTime = computed(() => {
            return AppState.isNewBlockSlot ? true : AppState.shouldAllowCustomTime;
        });
        const isRecurringEnabled = computed(() => {
            return !!(AppState === null || AppState === void 0 ? void 0 : AppState.isRecurringEnabled);
        });
        const showRecurringSection = computed(() => {
            var _a;
            const isRecurringCalendar = ((_a = selectedCalendar.value) === null || _a === void 0 ? void 0 : _a.isRecurringCalendar) &&
                !isEditingAppointment.value &&
                !shouldAllowCustomTime.value;
            return isRecurringEnabled.value && isRecurringCalendar;
        });
        // Computed property that generates meeting location types based on calendar type.
        const meetingLocationTypesNew = computed(() => {
            var _a;
            if (((_a = selectedCalendar.value) === null || _a === void 0 ? void 0 : _a.isV3Calendar) &&
                selectedCalendar.value.calendarType !== 'class_booking') {
                return [
                    {
                        label: t('meetingLocation.custom'),
                        value: 'custom',
                    },
                    {
                        label: t('meetingLocation.zoom'),
                        value: 'zoom',
                    },
                    {
                        label: t('meetingLocation.google_meet'),
                        value: 'gmeet',
                    },
                    {
                        label: t('meetingLocation.phone'),
                        value: 'phone',
                    },
                    {
                        label: t('meetingLocation.address'),
                        value: 'address',
                    },
                ];
            }
            return [
                {
                    label: t('meetingLocation.custom'),
                    value: 'custom',
                },
            ];
        });
        const showMeetingLocation = computed(() => {
            return appointmentWizardState.meetingLocationType.includes(appointmentWizardState.customizedLocationType);
        });
        // Updates the customLocation based on the selected value.
        const updateCustomLocationType = (value) => {
            if (value === 'phone' || value === 'address') {
                appointmentWizardState.customLocation =
                    appointmentWizardState.meetingLocation[value];
            }
            else if (value === 'custom') {
                appointmentWizardState.customLocation = '';
            }
        };
        const onClickAddRemoveDesc = () => {
            appointmentWizardState.showDescriptionInput =
                !appointmentWizardState.showDescriptionInput;
            appointmentWizardState.appointmentDescription = '';
        };
        const checkIfDateDisabled = (date) => {
            if (appointmentWizardState.isSlotsLoading) {
                return true;
            }
            return Boolean(appointmentWizardState.disabledDates.find(disabledDate => disabledDate.toString().trim() === date.toString().trim()));
        };
        onMounted(() => {
            window.addEventListener('resize', handleWindowResize);
            handleWindowResize(); // Initialize height value
        });
        onBeforeUnmount(() => {
            window.removeEventListener('resize', handleWindowResize);
        });
        const handleWindowResize = () => {
            const standardHeight = AppState.isNewBlockSlot
                ? 620
                : AppState.isEdit
                    ? 640
                    : 660;
            const baseHeight = AppState.isEdit || !AppState.showBlockedTimeAndContact ? 5 : 60;
            const windowHeight = window.innerHeight;
            const standardDesktopHeight = 1080;
            if (windowHeight <= standardDesktopHeight) {
                dynamicHeight.value = `${standardHeight - baseHeight}px`;
            }
            else {
                dynamicHeight.value = `460px`;
            }
        };
        watch(() => appointmentWizardState.autoSelectDate, newValue => {
            autoSelectDate(newValue);
        });
        const autoSelectDate = dateKey => {
            if (!myDatePicker.value) {
                return;
            }
            myDatePicker.value.selectDateItem({
                dateKey,
            }, true);
        };
        const fetchDataOnRefresh = () => __awaiter(this, void 0, void 0, function* () {
            isCalendarLoading.value = true;
            yield Promise.all([getCalendars(), getTeams(), getUsers()]);
            isCalendarLoading.value = false;
        });
        function isDateDisabled(ts, isStartDate) {
            const inputDate = new Date(ts);
            const currentDate = new Date();
            const startDate = new Date(appointmentWizardState.customStartTime);
            const comparisonDate = new Date(isStartDate
                ? appointmentWizardState.customStartTime
                : appointmentWizardState.customEndTime);
            const dates = [inputDate, currentDate, comparisonDate, startDate];
            dates.forEach(date => date.setHours(0, 0, 0, 0));
            if (AppState.isEdit) {
                return inputDate < comparisonDate;
            }
            else {
                return isStartDate ? inputDate < currentDate : inputDate < startDate;
            }
        }
        function isTimeDisabled(ts, isStartDate) {
            const currentDate = new Date();
            const currentHour = currentDate.getHours();
            const isHourDisabled = (hour) => {
                if (isStartDate) {
                    return (currentDate.getDate() === new Date(ts).getDate() && hour < currentHour);
                }
                else {
                    const startHour = new Date(appointmentWizardState.customStartTime).getHours();
                    return hour < startHour;
                }
            };
            return { isHourDisabled };
        }
        return (_ctx, _cache) => {
            var _a, _b, _c, _d;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "bookAppointmentFormContainer",
                    style: _normalizeStyle({
                        height: dynamicHeight.value,
                    })
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('appointmentModal.calendar')), 1),
                            (_unref(config).SHOW_REFRESH_ICON)
                                ? (_openBlock(), _createBlock(_unref(RefreshCcw05Icon), {
                                    key: 0,
                                    class: "w-5 h-5 text-gray-700 cursor-pointer",
                                    onClick: fetchDataOnRefresh
                                }))
                                : _createCommentVNode("", true)
                        ]),
                        _createVNode(_unref(UISelect), {
                            id: "book-appt-selected-calendar",
                            loading: isCalendarLoading.value,
                            value: _unref(appointmentWizardState).selectedCalendarId,
                            "onUpdate:value": [
                                _cache[0] || (_cache[0] = ($event) => ((_unref(appointmentWizardState).selectedCalendarId) = $event)),
                                _cache[1] || (_cache[1] = value => _unref(setSelectedCalendar)({ value }))
                            ],
                            options: _unref(calendarDropDownOptions)(false),
                            filterable: true,
                            placeholder: _ctx.$t('common.select_one'),
                            style: _normalizeStyle({
                                borderRadius: '8px',
                                border: _unref(appointmentWizardState).calendarError
                                    ? '1px solid var(--error-600)'
                                    : null,
                            })
                        }, null, 8, ["loading", "value", "options", "placeholder", "style"]),
                        (_unref(appointmentWizardState).calendarError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(appointmentWizardState).calendarError), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('appointmentModal.appointment_title')), 1),
                        _createVNode(_unref(UIInput), {
                            value: _unref(appointmentWizardState).appointmentTitle,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event) => ((_unref(appointmentWizardState).appointmentTitle) = $event)),
                            placeholder: _ctx.$t('appointmentModal.appointment_title_placeholder'),
                            id: "appointment-title-input"
                        }, null, 8, ["value", "placeholder"])
                    ]),
                    (_unref(appointmentWizardState).showDescriptionInput)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('appointmentModal.appointment_description')), 1),
                            _createVNode(_unref(UIInput), {
                                type: "textarea",
                                value: _unref(appointmentWizardState).appointmentDescription,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event) => ((_unref(appointmentWizardState).appointmentDescription) = $event)),
                                placeholder: _ctx.$t('appointmentModal.appointment_description'),
                                id: "notes-text-area"
                            }, null, 8, ["value", "placeholder"])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        id: "add-description-text",
                        class: "addDescriptionText",
                        style: _normalizeStyle({
                            color: _unref(appointmentWizardState).showDescriptionInput
                                ? 'var(--error-700)'
                                : 'var(--primary-700)',
                        }),
                        onClick: _withModifiers(onClickAddRemoveDesc, ["prevent"])
                    }, _toDisplayString(_unref(appointmentWizardState).showDescriptionInput
                        ? 'Remove Description'
                        : ' Add description'), 13, _hoisted_9),
                    ((_a = _unref(selectedCalendar)) === null || _a === void 0 ? void 0 : _a.isRoundRobinCalendar)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('appointmentModal.select_team_member')), 1),
                            _createVNode(_unref(UISelect), {
                                id: "team-member-dropdown",
                                value: _unref(appointmentWizardState).selectedTeamMember,
                                "onUpdate:value": [
                                    _cache[4] || (_cache[4] = ($event) => ((_unref(appointmentWizardState).selectedTeamMember) = $event)),
                                    _unref(setSelectedTeamMember)
                                ],
                                options: _unref(teamMemberOptions),
                                filterable: true,
                                placeholder: _ctx.$t('common.select_one')
                            }, null, 8, ["value", "options", "placeholder", "onUpdate:value"])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('appointmentModal.date_time')), 1),
                    _createElementVNode("div", _hoisted_13, [
                        (_unref(showRecurringSection))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_unref(UIRadio), {
                                        id: "recurrence-true",
                                        modelValue: _unref(appointmentWizardState).isRecurring,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(appointmentWizardState).isRecurring) = $event)),
                                        checked: _unref(appointmentWizardState).isRecurring === 'true',
                                        name: "location-type",
                                        class: "flex",
                                        size: "small",
                                        onChange: _cache[6] || (_cache[6] = ($event) => (_unref(appointmentWizardState).isRecurring = 'true'))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('appointmentModal.recurring_booking')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue", "checked"]),
                                    _createVNode(_unref(UIRadio), {
                                        id: "recurrence-false",
                                        modelValue: _unref(appointmentWizardState).isRecurring,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(appointmentWizardState).isRecurring) = $event)),
                                        checked: _unref(appointmentWizardState).isRecurring === 'false',
                                        name: "location-type",
                                        class: "flex",
                                        size: "small",
                                        onChange: _cache[8] || (_cache[8] = ($event) => (_unref(appointmentWizardState).isRecurring = 'false'))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('appointmentModal.one_slot_booking')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue", "checked"])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('appointmentModal.slots_title')), 1),
                        _createVNode(_unref(UISelect), {
                            id: "select-timezone-dropdown",
                            value: _unref(appointmentWizardState).selectedTimezone,
                            "onUpdate:value": [
                                _cache[9] || (_cache[9] = ($event) => ((_unref(appointmentWizardState).selectedTimezone) = $event)),
                                setSelectedTimezone
                            ],
                            options: _unref(computedTimezonesNew),
                            filterable: true,
                            placeholder: _ctx.$t('common.select_one')
                        }, null, 8, ["value", "options", "placeholder"]),
                        (_unref(hasContact) &&
                            _unref(appointmentWizardState).selectedTimezone !== _unref(contactTimezone) &&
                            !_unref(disableContactTimezone))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(_unref(UICheckbox), {
                                    id: "add-appointment-update-tz-checkbox",
                                    class: "text-[13px]",
                                    checked: _unref(appointmentWizardState).shouldOverrideContactTimezone,
                                    "onUpdate:checked": _cache[10] || (_cache[10] = ($event) => ((_unref(appointmentWizardState).shouldOverrideContactTimezone) = $event))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('appointmentModal.update_contact_tz')) + " " + _toDisplayString(_unref(appointmentWizardState).selectedTimezone), 1)
                                    ]),
                                    _: 1
                                }, 8, ["checked"]),
                                _createVNode(_unref(UITooltip), { placement: "top" }, {
                                    trigger: _withCtx(() => [
                                        _createVNode(_unref(HelpCircleIcon), { class: "ml-2 w-4 cursor-pointer" })
                                    ]),
                                    default: _withCtx(() => [
                                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('appointmentModal.tz_tooltip')), 1)
                                    ]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true),
                        (_unref(shouldAllowCustomTime))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('appointmentModal.start_time')), 1),
                                        _createVNode(_unref(UIDatepicker), {
                                            id: "custom-start-time",
                                            type: "datetime",
                                            value: _unref(moment)(_unref(appointmentWizardState).customStartTime).valueOf(),
                                            "parse-date": parseDate,
                                            "is-date-disabled": ts => isDateDisabled(ts, true),
                                            "is-time-disabled": ts => isTimeDisabled(ts, true),
                                            format: "PP p",
                                            "time-picker-props": {
                                                format: 'h:mm a',
                                                use12Hours: true,
                                            },
                                            "onUpdate:value": _unref(updateStartTime),
                                            placeholder: _ctx.$t('appointmentModal.select_time')
                                        }, null, 8, ["value", "is-date-disabled", "is-time-disabled", "onUpdate:value", "placeholder"])
                                    ]),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('appointmentModal.end_time')), 1),
                                        _createVNode(_unref(UIDatepicker), {
                                            id: "custom-end-time",
                                            type: "datetime",
                                            value: _unref(moment)(_unref(appointmentWizardState).customEndTime).valueOf(),
                                            "parse-date": parseDate,
                                            "is-date-disabled": ts => isDateDisabled(ts, false),
                                            "is-time-disabled": ts => isTimeDisabled(ts, false),
                                            format: "PP p",
                                            "time-picker-props": {
                                                format: 'h:mm a',
                                                use12Hours: true,
                                            },
                                            "onUpdate:value": _unref(updateEndTime),
                                            placeholder: _ctx.$t('appointmentModal.select_time')
                                        }, null, 8, ["value", "is-date-disabled", "is-time-disabled", "onUpdate:value", "placeholder"])
                                    ])
                                ])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('appointmentModal.date')), 1),
                                    (_openBlock(), _createBlock(UIDatePicker, {
                                        id: "date-picker-standard",
                                        ref_key: "myDatePicker",
                                        ref: myDatePicker,
                                        key: _unref(AppState).isLoading + '',
                                        modelValue: _unref(appointmentWizardState).appointmentDate,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(appointmentWizardState).appointmentDate) = $event)),
                                        format: _unref(appointmentWizardState).format,
                                        "parse-date": parseDate,
                                        "format-date": formatDate,
                                        "is-nav-button-disabled": _unref(appointmentWizardState).isSlotsLoading,
                                        "is-date-disabled": checkIfDateDisabled,
                                        onPeriodChange: periodChanged,
                                        onSlotPicked: _cache[12] || (_cache[12] = ($event) => (_unref(fetchSlots)(false)))
                                    }, null, 8, ["modelValue", "format", "is-nav-button-disabled"]))
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('appointmentModal.slot')), 1),
                                    (_unref(appointmentWizardState).appointmentSlots.length &&
                                        !_unref(appointmentWizardState).isSlotsLoading)
                                        ? (_openBlock(), _createBlock(_unref(UISelect), {
                                            filterable: true,
                                            id: "slot-picker-standard",
                                            placeholder: "Please select slot",
                                            key: _unref(appointmentWizardState).appointmentSlots.length + _unref(appointmentWizardState).selectedAppointmentSlot,
                                            value: _unref(appointmentWizardState).selectedAppointmentSlot,
                                            "onUpdate:value": _cache[13] || (_cache[13] = ($event) => ((_unref(appointmentWizardState).selectedAppointmentSlot) = $event)),
                                            options: _unref(appointmentWizardState).appointmentSlots,
                                            style: _normalizeStyle({
                                                borderRadius: '8px',
                                                border: _unref(appointmentWizardState).slotError
                                                    ? '1px solid var(--error-600)'
                                                    : null,
                                            })
                                        }, null, 8, ["value", "options", "style"]))
                                        : (_unref(appointmentWizardState).isSlotsLoading)
                                            ? (_openBlock(), _createBlock(_unref(UISpin), {
                                                key: 1,
                                                show: true,
                                                size: 25
                                            }))
                                            : (_openBlock(), _createBlock(_unref(UISelect), {
                                                key: 2,
                                                id: "slot-picker-empty",
                                                options: [],
                                                style: _normalizeStyle({
                                                    borderRadius: '8px',
                                                    border: _unref(appointmentWizardState).slotError
                                                        ? '1px solid var(--error-600)'
                                                        : null,
                                                })
                                            }, null, 8, ["style"])),
                                    (_unref(appointmentWizardState).slotError)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(appointmentWizardState).slotError), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ])),
                        (_unref(bookRecurring))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                (_unref(appointmentWizardState).isRecurringEventsLoading)
                                    ? (_openBlock(), _createBlock(_unref(UISpin), {
                                        key: 0,
                                        size: 25
                                    }))
                                    : (Array.isArray(_unref(recurringSlots)))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                            _createVNode(_unref(Repeat02Icon), { class: "w-4 h-4 mr-2 text-gray-500" }),
                                            _createElementVNode("div", _hoisted_31, [
                                                _createTextVNode(_toDisplayString((_b = _unref(recurringSlots)) === null || _b === void 0 ? void 0 : _b.filter(s => !s.isUnavailable).length) + "/" + _toDisplayString((_d = (_c = _unref(selectedCalendar)) === null || _c === void 0 ? void 0 : _c.recurring) === null || _d === void 0 ? void 0 : _d.count) + " " + _toDisplayString(_ctx.$t('appointmentModal.occurrences_booked')) + " ", 1),
                                                _createElementVNode("span", null, _toDisplayString(_unref(appointmentWizardState).rruleText) + ". ", 1),
                                                (_unref(recurringSlots).length > 0)
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 0,
                                                        class: "text-primary-700 cursor-pointer",
                                                        onClick: _cache[14] || (_cache[14] = _withModifiers(
                                                        //@ts-ignore
                                                        (...args) => (_unref(toggleRecurringModal) && _unref(toggleRecurringModal)(...args)), ["prevent"]))
                                                    }, _toDisplayString(_ctx.$t('appointmentModal.view_events')), 1))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("p", {
                            class: "mt-3 text-[#004EEB] cursor-pointer text-sm font-medium w-fit",
                            onClick: toggleShouldAllowCustomTime
                        }, _toDisplayString(_unref(shouldAllowCustomTime)
                            ? _ctx.$t('appointmentModal.standard')
                            : _ctx.$t('appointmentModal.custom')), 1)
                    ]),
                    (_unref(appointmentWizardState).serverError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_unref(appointmentWizardState).serverError), 1))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('appointmentModal.meeting_location')), 1),
                    _createElementVNode("div", _hoisted_34, [
                        _createVNode(_unref(UIRadio), {
                            id: "location-default",
                            checked: _unref(appointmentWizardState).locationType === 'default',
                            class: "w-38 mr-3 flex content-center items-center rounded-md bg-white py-3",
                            onChange: _cache[15] || (_cache[15] = ($event) => (_unref(appointmentWizardState).locationType = 'default'))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('appointmentModal.calendar_default')) + " ", 1),
                                _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t('appointmentModal.meeting_location_default_desc')), 1)
                            ]),
                            _: 1
                        }, 8, ["checked"]),
                        _createVNode(_unref(UIRadio), {
                            id: "location-custom",
                            checked: _unref(appointmentWizardState).locationType === 'custom',
                            class: "w-38 mr-3 flex content-center items-center rounded-md bg-white py-3",
                            onChange: _cache[16] || (_cache[16] = ($event) => (_unref(appointmentWizardState).locationType = 'custom'))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('appointmentModal.custom')) + " ", 1),
                                _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t('appointmentModal.meeting_location_custom_desc')), 1)
                            ]),
                            _: 1
                        }, 8, ["checked"])
                    ]),
                    (_unref(appointmentWizardState).locationType === 'custom')
                        ? (_openBlock(), _createBlock(_unref(UISelect), {
                            key: 3,
                            class: "mb-3",
                            id: "meeting-location-dropdown",
                            value: _unref(appointmentWizardState).customizedLocationType,
                            "onUpdate:value": [
                                _cache[17] || (_cache[17] = ($event) => ((_unref(appointmentWizardState).customizedLocationType) = $event)),
                                _cache[18] || (_cache[18] = value => updateCustomLocationType(value))
                            ],
                            options: _unref(meetingLocationTypesNew)
                        }, null, 8, ["value", "options"]))
                        : _createCommentVNode("", true),
                    (_unref(appointmentWizardState).locationType === 'custom' &&
                        _unref(showMeetingLocation))
                        ? (_openBlock(), _createBlock(_unref(UIInput), {
                            key: 4,
                            class: "mb-3",
                            id: "meeting-location-text-input",
                            modelValue: _unref(appointmentWizardState).customLocation,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_unref(appointmentWizardState).customLocation) = $event)),
                            placeholder: _ctx.$t('appointmentModal.meeting_location_label')
                        }, null, 8, ["modelValue", "placeholder"]))
                        : _createCommentVNode("", true),
                    _createVNode(RecurringEventsModal)
                ], 4),
                _hoisted_37,
                _createElementVNode("div", {
                    class: "viewContactsContainer",
                    style: _normalizeStyle({
                        height: dynamicHeight.value,
                    })
                }, [
                    _createVNode(ViewContacts)
                ], 4)
            ]));
        };
    }
});
